var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagesSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M576 32H96v352h480V32zM395.6 139.8l96 136 4.4 6.2v39.6H176v-41.1l6.1-6.8 64-72 17.9-20.2 17.9 20.2 17.2 19.3 57.3-81.2L376 112l19.6 27.8zM192 128a32 32 0 1164 0 32 32 0 11-64 0zm-144-8V96H0v384h480v-48H48V120z"
  })));
}
export default SvgImagesSolid;